import React from "react";
import MainInfoSkeleton from "./Skeletons/MainInfoSkeleton.jsx";
import ButtonSkeleton from "./Skeletons/ButtonSkeleton.jsx";
import SubmitBtn from "./submitButton.jsx";
import { scrollToElement } from "../utils/Utils.js";
// import styled from "@emotion/styled";

// const StyledLink = styled.a({
//   textDecoration: "none",
//   color: "#0D0C1C",
//   ":hover": {
//     textDecoration: "underline",
//   },
// });

const MainInfo = ({
  mainInfo,
  hasEventEnded,
  loading,
  fromPrice,
  ticketsButtonText,
  venueSeatsProp,
  lat,
  long,
  headerVisible,
  isStreaming
}) => {
  const renderLoadingContent = () => (
    <>
      <MainInfoSkeleton />
      {!hasEventEnded && <ButtonSkeleton />}
    </>
  );

  const renderMainContent = () => (
    <>
      <div className="r_info">
        <div id="r_maininfo" className="r_maininfo">
          <h1>{mainInfo.playTitle}</h1>
        </div>
        {!hasEventEnded && (
          <div className="r_maininfoSub">
            <div className="r_mainInfoLocation">
              <img
                src="/Site/images/icons/EventPage/locationPin.svg"
                className="r_mainInfoIcon"
              />
              <div className="r_mainInfoText">
                {
                  mainInfo.multipleVenues
                    ? playdetailsv2_resources.MultipleVenuesText
                    : isStreaming
                    ? mainInfo.playVenue
                    : mainInfo.playVenue + ", " + mainInfo.venueAddress + ", " + mainInfo.venueCity
                  // <StyledLink
                  //   target="_blank"
                  //   href={`https://www.google.com/maps?q=${lat?.replace(
                  //     ",",
                  //     "."
                  //   )},${long?.replace(",", ".")}`}
                  // >
                  //   {mainInfo.playVenue}
                  // </StyledLink>
                }
              </div>
            </div>
            <div className="r_mainInfoDate">
              <img
                src="/Site/images/icons/EventPage/datepicker.svg"
                className="r_mainInfoIcon"
              />
              <div className="r_mainInfoText">{mainInfo.playDate}</div>
            </div>
          </div>
        )}
      </div>
      {!hasEventEnded && renderButton()}
    </>
  );

  const renderButton = () => (
    <div className={"r_buybtn" + (!fromPrice.isVisible ? " r_soloBtn" : "")}>
      <div className="r_buttonPrice">
        {fromPrice.isVisible && (
          <div className="r_startingPrice">
            {playdetailsv2_resources.fromPriceText} {fromPrice.startingPrice}
          </div>
        )}
        <SubmitBtn
          buttonText={ticketsButtonText}
          toDoOnClick={() => scrollToElement(headerVisible, "workspace")}
          venueSeatsProp={venueSeatsProp}
        />
      </div>
    </div>
  );

  return (
    <div id="r_mainHeader">
      {loading ? renderLoadingContent() : renderMainContent()}
    </div>
  );
};

export default MainInfo;
